export default "/_next/static/images/cfaLogo-85ab0a64c75f192e7ae782bec7c95131.svg";